import FactoryComponents from '../../../../../factory/components/FactoryComponents.js';
import ProcessWorkPermitChoose from "../workPermit/ProcessWorkPermitChoose.vue";
import ProcessWorkPermitReview from "../workPermit/ProcessWorkPermitReview.vue";
import {
  submitToReview, getWorkType, getApplicantSelect, getWorkerByApplica, getEmpBindUser, workPermitYS,
  getPermisssionEmpList, getAlluser, getAllDepartment
} from '@/api/processManager'
import { downLoadDocument } from "@/api/downLoad"
import { modulesList } from "@/api/model.js"
import DrawMap from "@/views/map/drawMap";
import item from "@/components/components/home/specialExamination/item.vue";
const root = {}
export default root
root.name = 'processWorkPermit';

root.components = {
  DrawMap,
  ProcessWorkPermitChoose,
  ProcessWorkPermitReview,
  // 动态引入组件
  TemporaryElectricity(resolve) {
    require(["../complexityTable/temporaryElectricity"], resolve)
  },
  PremiumFirePlayer(resolve) {
    require(["../complexityTable/premiumFirePlayer"], resolve)
  },
  RestrictedSpace(resolve) {
    require(["../complexityTable/restrictedSpace"], resolve)
  },
  BlindBoard(resolve) {
    require(["../complexityTable/blindBoard"], resolve)
  },
  HighPlaceWork(resolve) {
    require(["../complexityTable/highPlaceWork"], resolve)
  },
  HoistingWork(resolve) {
    require(["../complexityTable/hoistingWork"], resolve)
  },
  BreakRoad(resolve) {
    require(["../complexityTable/breakRoad"], resolve)
  },
  Groundbreaking(resolve) {
    require(["../complexityTable/groundbreaking"], resolve)
  }
};
root.data = {
  thisDBname: "",
  isDetail: false, // 查看详情的时候禁止保存
  currentEmpId: Number(localStorage.getItem("empId")),//获取当前用户id
  isVisibleDrawMap: false,
  workPermitData: {
    //总页数
    total: 1,
    //每页多少行
    limit: 10,
    //当前页数
    thisPage: 1,
    //查询条件
    selectCondition: '',
    //状态
    status: '',
    //数据
    data: [],
    //作业证选择类型
    workPermitType: {},
    //当前缓存数据
    operaDataCache: {
      //作业证类型
      permitType: 1,
      definitionId: 0
    },

    //区域数据
    areaData: {
      data: [],
    },
    // 防护用品的值
    valueFh: [],
    valuePriority: '', // 优先级的值
    toReviewDia: false, // 复核弹窗的状态
    toReviewObj: {//TODO:复核对象
      id: '',
      reviewOpinion: '',//TODO:复核意见
      buildingPic: '',
      buildingAfterPic: '',
      isQualified: 1
    }, // 复核需要发送的数据
    rules: {
      reviewOpinion: [{ required: true, message: '请输入复核意见' }],
      buildingAfterPic: [{ required: true, message: '整改后照片' }]
    },

    //人员数据
    userData: {
      data: [],
    },
    // 表单规则0227
    workPermitRules: {
      certificateTypeId: [
        { required: true, message: "请选择类型", trigger: "change" }
      ],
    }
  },
  operaDataType: {
    //等于0是查看，1是新增或编辑
    type: 0,
  },

  //审核操作
  reviewData: {
    //显示审核界面
    showOpera: false,
    //抽屉的背景颜色
    drawerStyles: {
      backgroundColor: "#f7f7f7",
    },
    //当前审核数据
    data: {},
  },
  // 防护用品的值
  valueFh: [],
  valuePriority: '', // 优先级的值
  toReviewDia: false, // 复核弹窗的状态
  toReviewObj: {//TODO:复核对象
    id: '',
    reviewOpinion: '',//TODO:复核意见
    buildingPic: '',
    buildingAfterPic: '',
    isQualified: 1
  }, // 复核需要发送的数据
  rules: {
    reviewOpinion: [{ required: true, message: '请输入复核意见' }],
    buildingAfterPic: [{ required: true, message: '请上传施工后照片' }]
  },
  // 申请单位
  applicantSelect: [],
  // 作业人的数组
  workerSelect: [],
  // 验收的弹窗
  checkBeforeAccDia: false,
  checkBeforeAccForm: {//TODO:完工验收
    reviewType: 1,
    reviewOpinion: ''//TODO:完工验收意见
  },
  checkBeforeAccRules: {
    reviewOpinion: [{ required: true, message: '请输入验收意见' }]
  },

  // 上传附件
  fileList: [],
  /// 动态引入打印预览弹窗的数据
  currentComponent: "",
  customer_id: '',
  dialogVisible: false,
  message: {},
  userList: [], // 绑定了用户的人员，传到打印的组件里面去用于id反查用户名
  deptList: [],
  sysUserList: [],
  // 模板的数组
  modules: [],
  currentType: null, // 当前作业类型
}

root.methods = {
  closeCoord(drawData) {
    if (drawData) {
      this.workPermitData.operaDataCache.longitude = drawData.positions[0];
      this.workPermitData.operaDataCache.latitude = drawData.positions[1];
    }
    this.isVisibleDrawMap = false;
  },
  //获取作业列表
  getWorkPermit: function (page) {
    this.workPermitData.thisPage = page
    const that = this;
    const data = {};
    data.searchParam = this.workPermitData.selectCondition;
    data.curPage = page;
    data.status = this.workPermitData.status;
    data.limit = this.workPermitData.limit;
    data.certificateTypeId = this.$route.query.type;
    this.componentsMoudel.startPost('/workPermit/list_all', data, true).then(res => {

      that.workPermitData.data = res.body.data === null ? [] : res.body.data;
      that.workPermitData.total = res.body.cum;
      // that.workPermitData.thisPage = res.body.page;
    })
  },

  //状态选择点击时查询
  statusChoose: function () {
    this.getWorkPermit(this.workPermitData.thisPage);
  },

  //删除作业数据
  delWorkPermit: function (data) {
    const that = this;
    this.$confirm(`删除作业 《${data.name}》, 是否继续?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.componentsMoudel.startPost('/workPermit/delete/' + data.id, null, true).then(res => {
        if (this.workPermitData.data.length <= 1 && this.workPermitData.thisPage > 1) {
          this.workPermitData.thisPage -= 1
        }
        that.getWorkPermit(that.workPermitData.thisPage);
        this.$message.success('删除成功')
      })
    }).catch(() => {
      return
    });
  },

  //获取用户数据
  getUserAll: function (page) {
    if (this.workPermitData.userData.data.length === 0) {
      // 获取有权限的人员数据
      let arr = JSON.parse(localStorage.getItem('Permission'))
      for (let i in arr) {
        if (arr[i].menuName !== '列表') {
          this.getPermisssionEmpList(arr[i].id, arr[i].menuName)
        }
      }
    }
  },

  // 获取有当前页面审批权限的人员的列表
  getPermisssionEmpList(id, status) {
    getPermisssionEmpList({ permissionId: id }).then(res => {
      this.workPermitData.userData.data = res.body.data === null ? [] : res.body.data;
    })
  },

  // 获取作业证类型列表
  getWorkType() {
    getWorkType({ type: 1 }).then(res => {
      res.body.data[0].childList.map((item) => {
        if (this.$route.query.type == item.id) {
          this.workPermitData.workPermitType = item;
        }
      })
      this.workPermitData.operaDataCache.certificateTypeId = this.$route.query.type
    })
  },

  //获取区域数据
  getArea: function (page) {
    if (this.workPermitData.areaData.data.length === 0) {
      const that = this;
      this.componentsMoudel.startGet('/dangerinfo/list_all?limit=500&curPage=1', null, true).then(res => {
        that.workPermitData.areaData.data = res.body.data === null ? [] : res.body.data;
      })
    }
  },

  // 根据申请单位查询作业人列表
  applicantChange(val, status) {
    if (val === '' || val === undefined) {
      return
    }
    getWorkerByApplica({
      certificateTypeId: this.workPermitData.operaDataCache.certificateTypeId,
      contractorId: val
    })
      .then(res => {
        // status用来判断是否为编辑，编辑的时候调这个接口不清空作业人
        if (!status) {
          this.workPermitData.operaDataCache.jobExecutorEmpId = ''
        }
        this.workerSelect = res.body.data
      })
  },

  // 缓存涉及的其他特殊作业及编号
  setPreWorkInfoCache: function (data) {
    let preWorkInfo = data && data.preWorkInfo;
    if (typeof preWorkInfo === 'string') {
      try {
        preWorkInfo = preWorkInfo ? JSON.parse(preWorkInfo) : [];
      } catch (e) {
        preWorkInfo = [];
      }
    }
    if (!Array.isArray(preWorkInfo)) {
      preWorkInfo = [];
    }
    this.$store.commit('setPreWorkInfo', preWorkInfo)
  },

  //点击新增或者编辑操作
  operaWorkPermit: async function (row, certificateTypeId, status) {
    if (row) {
      const res = await this.componentsMoudel.startPost('/workPermit/info', { id: row.id, certificateTypeId: certificateTypeId }, true);
      let data = res.body.data;
      if (data.fileUrl) {
        this.fileList.push({
          name: data.fileName,
          response: { data: data.fileUrl }
        })
      }
      this.workPermitData.operaDataCache = { ...data };
      this.setPreWorkInfoCache(data);
      this.valueFh = data.protectionProduct?.split(',')
      this.valuePriority = data.riskGrade
      // 编辑的时候通过申请单位来调取作业人的列表
      this.applicantChange(this.workPermitData.operaDataCache.contractorId, true)
    } else {
      // 新增作业
      this.valueFh = []
      this.valuePriority = ''
      this.workerSelect = []
      this.setPreWorkInfoCache()
    }
    if (status) {
      this.isDetail = status
    }
    this.getUserAll();
    this.getArea();
    this.operaDataType.type = 1;
  },

  // 上传的事件
  handleChange(file, fileList) {
    this.fileList = fileList
  },
  handleExceed(file, fileList) {
    this.$message.warning('限制上传一个文件')
  },


  // 获取模板列表
  getModulesList() {
    modulesList().then(res => {
      this.modules = res.body.data
    })
  },
  // 模板更改
  modelChange(a) {
    let obj = {}
    obj = this.modules.find(v => {
      return a === v.definitionId
    })
    this.workPermitData.operaDataCache.key = obj.key
  },

  //保存数据
  saveData: async function (isSend) {
    let protection = this.valueFh.join(',')
    const data = { ...this.workPermitData.operaDataCache, protectionProduct: protection };
    // return
    // 下面是验证安全措施确认人填完（不然工作流画不了）
    let str = ''
    let cacheData = this.$refs.workPermitChoose.returnCacheData();
    if (cacheData.firePropsDto) {
      str = 'firePropsDto'
    } else if (cacheData.openCircuitPropsDto) {
      str = 'openCircuitPropsDto'
    } else if (cacheData.blindBoardPropsDto) {
      str = 'blindBoardPropsDto'
    } else if (cacheData.diggingPropsDto) {
      str = 'diggingPropsDto'
    } else if (cacheData.hoistingPropsDto) {
      str = 'hoistingPropsDto'
    } else if (cacheData.heightWorkPropsDto) {
      str = 'heightWorkPropsDto'
    } else if (cacheData.electricityPropsDto) {
      str = 'electricityPropsDto'
    } else if (cacheData.restrictedPropsDto) {
      str = 'restrictedPropsDto'
    }
    for (let i in cacheData[str].sms) {
      if (cacheData[str].sms[i].isInvolve == undefined) {
        this.$message.warning('请选择安全措施是否涉及!')
        return
      }
      if (!cacheData[str].sms[i].confirmorId) {
        this.$message.warning('请选择安全措施确认人!')
        return
      }
    }
    // return
    cacheData.protectionProduct = this.valueFh.join(',')
    if (this.fileList.length > 0) {
      cacheData.fileName = this.fileList[0].name
      cacheData.fileUrl = this.fileList[0].response.data
    }
    if (!data.id) {
      await this.componentsMoudel.startPost('/workPermit/save', { ...cacheData, preWorkInfo: JSON.stringify(this.$store.state.preWorkInfo.preWorkInfo) }, true).then(res1 => {
        this.workPermitData.operaDataCache = res1.body.data;
        this.$refs.workPermitChoose.dataBackfill(this.workPermitData.operaDataCache);
      })
    }
    cacheData = this.$refs.workPermitChoose.returnCacheData();
    cacheData.protectionProduct = this.valueFh.join(',')
    if (this.fileList.length > 0) {
      cacheData.fileName = this.fileList[0].name
      cacheData.fileUrl = this.fileList[0].response.data
    }
    const updateData = { ...data, ...cacheData };
    updateData.preWorkInfo = JSON.stringify(this.$store.state.preWorkInfo.preWorkInfo);
    await this.componentsMoudel.startPost('/workPermit/update', updateData, true).then(res2 => {
      this.getWorkPermit(this.workPermitData.thisPage);
      this.operaDataType.type = 0;
      this.fileList = []
      if (isSend) {
        this.sendReviewData(this.workPermitData.operaDataCache);
      }
    })
  },

  //作业证类型选择操作
  permitTypeChange: function (value) {
    this.operaWorkPermit(undefined, value);
  },


  // 关闭审核抽屉刷新页面
  closeDrawer() {
    this.getWorkPermit()
  },


  //获取审核数据
  getReviewData: async function (row) {
    this.getUserAll();
    const data = { id: row.id, certificateTypeId: row.certificateTypeId };
    const res = await this.componentsMoudel.startPost('/workPermit/info', data, true);
    this.reviewData.data = res.body.data;
    this.reviewData.showOpera = true;
  },

  reviewDataCallBack: function (data) {
    this.getReviewData(data);
  },

  //发送审核
  sendReviewData: async function (row) {
    await this.componentsMoudel.startPost('/workPermit/sendReview/' + row.id, null, true);
    this.getWorkPermit(this.workPermitData.thisPage);
  },

  // 开始作业和完成作业的按钮
  startOrFinishWorkBtn(row) {
    this.componentsMoudel.startPost('/workPermit/startOrFinishWork/' + row.id, null, true).then(res => {
      this.$message.success('操作成功')
      this.getWorkPermit(this.workPermitData.thisPage);
    });
  },
  //TODO 验收弹窗事件
  checkBeforeAcceptance: function (row) {
    this.checkBeforeAccForm.permitId = row.id
    this.checkBeforeAccForm.reviewOpinion = row.acceptanceOpinion;
    this.checkBeforeAccDia = true
  },

  // 关闭验收弹窗
  closeCheckBeforeAccDia() {
    this.$refs['checkBeforeAccForm'].resetFields();
    this.checkBeforeAccDia = false;
    this.checkBeforeAccForm.reviewType = 1
    this.checkBeforeAccForm.reviewOpinion = ''
  },

  // 验收的提交
  submitCheckBeforeAcc() {
    this.$refs['checkBeforeAccForm'].validate((valid) => {
      if (valid) {

        workPermitYS({ ...this.checkBeforeAccForm }).then(res => {
          this.$message.success('操作成功')
          this.closeCheckBeforeAccDia()
          this.getWorkPermit(this.workPermitData.thisPage)
        })
      } else {
        return false;
      }
    });
  },


  //TODO 复核弹窗的事件
  toReviewBtn(row) {
    this.toReviewDia = true
    this.toReviewObj.id = row.id
  },
  // 复核上传照片
  handleAvatarSuccess1(res, file) {
    this.toReviewObj.buildingPic = res.data.imageUrl
  },
  handleAvatarSuccess2(res, file) {
    this.toReviewObj.buildingAfterPic = res.data.imageUrl
  },
  // 关闭弹窗
  closeToReviewDia() {
    this.$refs['toReviewForm'].resetFields();
  },
  // 提交复核
  submitToReview() {
    this.$refs['toReviewForm'].validate((valid) => {
      if (valid) {
        submitToReview({ ...this.toReviewObj }).then(res => {
          this.$message.success('提交成功')
          this.toReviewDia = false
          this.toReviewObj = { id: '', buildingPic: '', buildingAfterPic: '', isQualified: 1 }
          this.getWorkPermit(this.workPermitData.thisPage)
        })
      } else {
        return false;
      }
    });
  },

  // 下载附件
  downBtn(url, name) {
    downLoadDocument(url, name)
  },

  uploadWorkPermit: function (data) {
    const that = this;
    this.componentsMoudel.startPost('/workPermit/upload/' + data.id, data, true).then(res => {
      if (this.workPermitData.data.length <= 1 && this.workPermitData.thisPage > 1) {
        this.workPermitData.thisPage -= 1
      }
      that.getDangerGovern(that.workPermitData.thisPage);
      this.$message.success('上报成功')
    })
  },
  // 动态引入组件的事件
  async handleSchedule(row) {
    const type = this.$route.query.type;
    const res = await this.componentsMoudel.startPost('/workPermit/info', {
      id: row.id,
      certificateTypeId: row.permitType
    }, true);
    let obj = { ...res.body.data }
    if (type === '3') {
      this.currentComponent = 'TemporaryElectricity' // 临时用电安全
    } else if (type === '4') {
      this.currentComponent = 'PremiumFirePlayer' // 动火
    } else if (type === '7') {
      this.currentComponent = 'RestrictedSpace' // 受限空间
    } else if (type === '8') {
      this.currentComponent = 'BlindBoard' // 盲板抽堵
    } else if (type === '9') {
      this.currentComponent = 'HighPlaceWork' // 高出作业
    } else if (type === '10') {
      this.currentComponent = 'HoistingWork' // 吊装安全作业
    } else if (type === '11') {
      this.currentComponent = 'BreakRoad' // 断路安全作业人
    } else if (type === '12') {
      this.currentComponent = 'Groundbreaking' // 动土
    }else if (type === '13') {
      this.currentComponent = 'Groundbreaking' // 检修安全作业
    }

    if (typeof obj.businessJson !== 'object') {
      obj.businessJson = JSON.parse(obj.businessJson)
    }
    if (typeof obj.reviewContentJson !== 'object') {
      obj.reviewContentJson = JSON.parse(obj.reviewContentJson)
    }
    if (typeof obj.reviewLogJson !== 'object') {
      //obj.reviewLogJson = JSON.parse(obj.reviewLogJson)
    }

    obj.applicant = this.getApplicant(obj.contractorId || '0');
    this.message = obj
    this.customer_id = row.id;
    this.dialogVisible = true
  },

  /**
   * 获取申请单位
   * @param id
   * @returns {string|[{message: string, required: boolean}]|*}
   */
  getApplicant(id) {
    for (let i in this.applicantSelect) {
      if (Number(id) === this.applicantSelect[i].id) {
        return this.applicantSelect[i]
      }
    }
  },
  /**
   * TODO:关闭作业票对话框
   */
  closeWorkPermitDialog() {
    this.operaDataType.type = 0;
    this.fileList = [];
    this.isDetail = false;
    this.workPermitData.operaDataCache = {};
    this.workPermitData.operaDataCache.certificateTypeId = this.$route.query.type
  },

  componentResult(status) {
    this.dialogVisible = status
  },
  /**
   * TODO:获取员工名
   * @param id
   * @returns {string}
   */
  getEmpName(id) {
    let empName = "-";
    this.userList.forEach(item => {
      if (id == item.id) {
        empName = item.name;
      }
    })
    return empName;
  },
  getContractor(id){
    let contractor = "-";
    this.applicantSelect.forEach(item => {
      if (id == item.id){
        contractor = item.contrName
      }
    })
    return contractor;
  },
  /**
   * TODO 根据用户id获取用户名
   * @param id
   * @returns {*}
   */
  getUserName(id) {
    let userName = "-";
    this.sysUserList.forEach(item => {
      if (id == item.id) {
        userName = item.nickname;
      }
    })
    return userName;
  },
  /**
   * TODO:格式化日期时间
   * @param row
   * @param column
   * @param cellValue
   * @param index
   * @returns {string}
   */
  formatterTime(row, column, cellValue, index) {
    return cellValue || "-";
  }
}
root.mounted = function () {
  this.thisDBname = localStorage.getItem('manufacturer')
  this.$store.commit('setPreWorkInfo', [])
  this.currentType = Number(this.$route.query.type);
  if (this.$route.query.workPermitNo) {
    this.workPermitData.selectCondition = this.$route.query.workPermitNo;
  }
  this.getWorkPermit(1);
  this.getWorkType();// 获取作业证类型
  this.getModulesList()
  // 获取申请单位的数据
  getApplicantSelect().then(res => {
    this.applicantSelect = []
    this.applicantSelect.push({ id: 0, contrName: "本企业" }, ...res.body.data)
  })
  // 查询绑定了用户的员工
  getEmpBindUser().then(res => {
    this.userList = res.body.data;
  })
  getAllDepartment().then(res => {
    this.deptList = res.body.data;
  })
  //TODO 获取系统所有用户
  getAlluser().then(res => {
    this.sysUserList = res.body.data
  })

}

FactoryComponents.initComponent(root);
